export const ERROR_NO_WIDTH_HEIGHT = 'Width nor height parameters are defined';
export const ERROR_NO_ASPECT = 'Aspect parameter not defined';
export const ERROR_INVALID_DIMENSION = 'Invalid dimension argument';

export function aspect(aspect, width, height){
	// allow an object to be passed as first argument
	if (typeof aspect === 'object'){
		width = aspect.width;
		height = aspect.height;
		aspect = aspect.aspect;
	}
	if (typeof aspect === 'undefined'){
		throw new Error(ERROR_NO_ASPECT);
	}
	if (typeof width === 'undefined' && typeof height === 'undefined'){
		throw new Error(ERROR_NO_WIDTH_HEIGHT);
	}
	if (typeof height === 'undefined'){
		width = parseFloat(width);
		if (isNaN(width) || width < 0){
			throw new Error(ERROR_INVALID_DIMENSION);
		}
		return width / aspect;
	}
	if (typeof width === 'undefined'){
		height = parseFloat(height);
		if (isNaN(height) || height < 0){
			throw new Error(ERROR_INVALID_DIMENSION);
		}
		return height * aspect;
	}
}